import React from 'react'
import { TablePlugin } from '../../../../plugins/components/TablePlugin'
import { useGetEnfermedadesTransmicionSexualQuery } from '../../../../services/rtk-query/clinicalApi'

export const Lista = ({ columns }) => {
  const { data, isFetching } = useGetEnfermedadesTransmicionSexualQuery()
  return (
    <>
      <TablePlugin data={data ?? []} columns={columns} isFetching={isFetching} />
    </>
  )
}
